export default __webpack_public_path__ + "static/media/power-line.1305620e.svg";